function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Form, Button, Select, Statistic, Descriptions, Modal, Switch, message, Divider, Alert, Upload, List, Typography } from "antd";
import { Cash, ExclamationCircleFill, Upload as UploadIc } from "react-bootstrap-icons";
import Common from "./includes/Common";
import Receipt from "./Receipt";
import moment from "moment";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var ManageOrder = function ManageOrder(_ref) {
  var handler = _ref.handler,
    customer = _ref.customer,
    items = _ref.items,
    queueItem = _ref.queueItem;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    itemOptions = _useState2[0],
    setItemOptions = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    itemsTotalAmount = _useState4[0],
    setItemsTotalAmount = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedItems = _useState6[0],
    setSelectedItems = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    successMessage = _useState0[0],
    setSuccessMessage = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    serviceTree = _useState10[0],
    setServiceTree = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isFormLoading = _useState12[0],
    setIsFormLoading = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    file = _useState14[0],
    setFile = _useState14[1];
  var _useState15 = useState(customer.category == 0),
    _useState16 = _slicedToArray(_useState15, 2),
    companyDisabled = _useState16[0],
    setCompanyDisabled = _useState16[1];
  var _useState17 = useState(customer.category == 0),
    _useState18 = _slicedToArray(_useState17, 2),
    uploadDisabled = _useState18[0],
    setUploadDisabled = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    companies = _useState20[0],
    setCompanies = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    companyOptions = _useState22[0],
    setCompanyOptions = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    rdata = _useState24[0],
    setRdata = _useState24[1];
  var _useState25 = useState(customer.company),
    _useState26 = _slicedToArray(_useState25, 2),
    userCompany = _useState26[0],
    setUserCompany = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    receipAmount = _useState28[0],
    setReceipAmount = _useState28[1];
  var handleItemChange = function handleItemChange(value) {
    var amount = 0;
    setSelectedItems(value);
    value.forEach(function (e) {
      items.forEach(function (i) {
        if (i.business_account_medical_item.id == e) amount += i.business_account_medical_item.base_price;
      });
    });
    setRdata(rdata.filter(function (d) {
      return value.includes(d.id);
    }));
    setItemsTotalAmount(amount);
  };
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    }
  };
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];
  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      setCompanyDisabled(false);
      form.setFieldsValue(customer.company.id);
      setUploadDisabled(false);
      setUserCompany(companies.filter(function (c) {
        return c.id == customer.company.id;
      })[0]);
    } else {
      setUploadDisabled(true);
      setCompanyDisabled(true);
      setUserCompany(null);
    }
  };
  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };
  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var onFinish = function onFinish(values) {
    var formData = new FormData();
    formData.append('items', values.items);
    formData.append('customer_id', customer.id);
    formData.append("user_id", Common.currentUser.id);
    formData.append('file', file);
    formData.append("amount", itemsTotalAmount);
    formData.append("category", values.category);
    formData.append("company_id", values.company_id);
    if (values.category == 1) {
      setUserCompany(companies.filter(function (c) {
        return c.id == values.company_id;
      })[0]);
      formData.append('company_part', itemsTotalAmount * userCompany.rate * 0.01);
      formData.append('patient_part', itemsTotalAmount * (100 - userCompany.rate) * 0.01);
      setReceipAmount(itemsTotalAmount * (100 - userCompany.rate) * 0.01);
    } else {
      formData.append("patient_part", itemsTotalAmount);
      formData.append("company_part", 0);
      setReceipAmount(itemsTotalAmount);
    }
    formData.append("queue_id", queueItem.id);
    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsx(Receipt, {
        company: userCompany,
        options: values.items,
        serviceTree: serviceTree
      }),
      onOk: function onOk() {
        execOrder(formData);
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'processorder', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
        printR();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage(error.toString());
    });
  };
  useEffect(function () {
    var ar = new Array();
    var amount = 0;
    setCompanies([]);
    setSelectedItems(items);
    items.forEach(function (e) {
      setItemOptions(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          value: e.business_account_medical_item.id,
          label: e.business_account_medical_item.label
        }]);
      });
      setRdata(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: e.business_account_medical_item.id,
          label: e.business_account_medical_item.label + " - " + e.business_account_medical_item.base_price.toLocaleString('fr') + " GNF"
        }]);
      });
      ar.push(e.business_account_medical_item.id);
      amount += e.business_account_medical_item.base_price;
    });
    setItemsTotalAmount(amount);
    form.setFieldsValue({
      items: ar
    });
    var cr = axios.get(Common.baseApiUrl + "getcompanylist/" + Common.currentUser.id);
    var st = axios.get(Common.baseApiUrl + "getservicetree/" + Common.currentUser.id);
    axios.all([cr, st]).then(function (response) {
      var crResponse = response[0];
      var stResponse = response[1];
      if (crResponse.data.status == 200) {
        setCompanies(crResponse.data.companyList);
        crResponse.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else
            //setCompanyOptions(prev => [...prev, {label: c.company.label+"-"+c.label, value: c.id}]);
            setCompanyOptions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                label: c.company == null ? "" : c.company.label + "-" + c.label,
                value: c.id
              }]);
            });
        });
        form.setFieldsValue({
          insurance_company_id: companyOptions
        });
      }
      if (stResponse.data.status == 200) {
        setServiceTree(stResponse.data.services);
      }
    })["catch"](function (error) {});
    form.setFieldsValue({
      category: customer.category
    });
    form.setFieldsValue({
      company_id: customer.company != null ? customer.company.id : null
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [customer != null && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/logo_sos.jpeg",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", customer.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", customer.firstname + " " + customer.lastname]
      }), /*#__PURE__*/_jsx(List, {
        header: /*#__PURE__*/_jsx("div", {
          children: "Actes / Produit(s)"
        }),
        footer: /*#__PURE__*/_jsx("b", {
          children: "TOTAL (GNF) " + receipAmount.toLocaleString('fr')
        }),
        bordered: true,
        dataSource: rdata,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(Typography.Text, {
              mark: true,
              children: item.label
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), userCompany != null && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        banner: true,
        message: "Prise en charge de " + userCompany.rate.toString() + "% par " + userCompany.label
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kaloum, Manquepas - Tel: 622 32 59 32"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              borderRight: '1px solid #F0F0F0',
              paddingRight: '10px'
            },
            children: [/*#__PURE__*/_jsxs(Form, {
              layout: "vertical",
              form: form,
              onFinish: onFinish,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "items",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(Select, {
                  onChange: handleItemChange,
                  mode: "multiple",
                  optionLabelProp: "label",
                  options: itemOptions
                })
              }), /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    name: "category",
                    label: "Cat\xE9gorie",
                    rules: [{
                      required: true,
                      message: 'Choisir la catégorie'
                    }],
                    children: /*#__PURE__*/_jsx(Select, {
                      showSearch: true,
                      onChange: onCategorieChanged,
                      optionLabelProp: "label",
                      defaultValue: [customer.category],
                      value: [customer.category],
                      optionFilterProp: "label",
                      filterOption: function filterOption(input, option) {
                        return option.label.toLowerCase().includes(input.toLowerCase());
                      },
                      options: categoryOptions
                    })
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    name: "company_id",
                    label: "Prise en charge",
                    children: /*#__PURE__*/_jsx(Select, {
                      onChange: onCompanyChanged,
                      disabled: companyDisabled,
                      defaultValue: [customer.company != null ? customer.company.id : null],
                      value: [customer.company != null ? customer.company.id : null],
                      showSearch: true,
                      options: companyOptions
                    })
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    label: "Bon de prise en charge",
                    children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                      children: /*#__PURE__*/_jsx(Button, {
                        disabled: uploadDisabled,
                        icon: /*#__PURE__*/_jsx(UploadIc, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Charger le bon"
                        })
                      })
                    }))
                  })
                })]
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  disabled: selectedItems.length == 0,
                  size: "large",
                  loading: isFormLoading,
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "VALIDER"
                  })
                })
              }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
                type: "error",
                banner: true,
                message: errorMessage
              }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
                type: "success",
                banner: true,
                message: successMessage
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              className: "price_box",
              children: /*#__PURE__*/_jsx(Statistic, {
                size: "large",
                title: "Montant (GNF)",
                value: itemsTotalAmount,
                prefix: /*#__PURE__*/_jsx(Cash, {
                  size: 30
                })
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            children: [customer && /*#__PURE__*/_jsxs(Descriptions, {
              column: 2,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                labelStyle: {
                  fontWeight: 'Bold'
                },
                span: 2,
                contentStyle: {
                  fontWeight: 'Bold'
                },
                label: "ID PATIENT",
                children: customer.idnumber
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Pr\xE9nom"
                }),
                children: customer.firstname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Nom"
                }),
                children: customer.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Tel."
                }),
                children: customer.mobile.toString().slice(3)
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Genre"
                }),
                children: customer.gender == 'F' ? "Femme" : "Homme"
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "D. Naissance"
                }),
                children: /*#__PURE__*/_jsx(Moment, {
                  format: "DD/MM/YYYY",
                  children: customer.birthdate
                })
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Profession"
                }),
                children: customer.job
              })]
            }), /*#__PURE__*/_jsx(Divider, {}), queueItem && queueItem.department.dcode == "LUN" && items.length > 0 && items[0].bilan_prescrit != null && /*#__PURE__*/_jsx("div", {
              style: {
                background: "#FBDC76",
                padding: "10px"
              },
              className: "cool-radius",
              children: /*#__PURE__*/_jsxs(Descriptions, {
                column: 2,
                title: /*#__PURE__*/_jsx("b", {
                  children: "DETAILS LUNETTE"
                }),
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "EP"
                  }),
                  children: [items[0].bilan_prescrit.glass_prescription_details.ep, " mm"]
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "SPHERE GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.sphere_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CYLINDRE GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.cylindre_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "ADDITION GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.addition_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "AXE GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.axe_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "SPHERE DROITE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.sphere_d
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CYLINDRE DROIT"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.cylindre_d
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "ADDITION DROITE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.addition_d
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "AXE DROIT"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.axe_d
                })]
              })
            })]
          })
        })]
      })
    })]
  });
};
export default ManageOrder;